import { useDispatch, useSelector } from "react-redux";
import { Alert, Button, Grid, Modal, Progress} from '@mantine/core';
import intl from "react-intl-universal";
import { useEffect, useState } from "react";
import { remove_klientidAustriaaccept} from '../../slice/mainslice'




const TimerDisplay = (props:any) => { 
    const dispatch = useDispatch()
    const drnId = useSelector((state: any) => state.user.meetinginfo.drnId)
    const [opened, setOpened] = useState(false);
    const [seconds, setSeconds] = useState(props.seconds);

   // console.log(drnId)

    let modalheadertext
    let modalcontenttext
    let modalbuttontext

    if (props.timerview === "pop"){
      modalheadertext = intl.get('IDA_LOADER_CLIENT_NOTOK_HEADER')
      modalcontenttext = intl.get('IDA_LOADER_CLIENT_NOTOK')
      modalbuttontext = intl.get('IDA_LOADER_CLIENT_MODAL_RESET')

    }
    if (props.timerview === "loader"){
      modalheadertext = intl.get('IDA_LOADER_CLIENT_NOTOK_HEADER')
      modalcontenttext = intl.get('IDA_LOADER_TIMEOUT_CONTENT')
      modalbuttontext = intl.get('IDA_LOADER_CLIENT_MODAL_RESET')
    }

    const handleOpen = () => {
        setOpened(true);
      };
    
      const handleClose = () => {
        setOpened(false);
      };

      const handleOkClick = () => {
        const closepopuppayload = {
          drnId: drnId,
          meetingParticipantId: props.meetingParticipantId,
        }
      
        dispatch({ type: 'SIGNALR_CLOSEDRNPOPUP', payload: closepopuppayload });


        const removepayload ={
        meetingParticipantId: props.meetingParticipantId,
        }

        handleClose();
        dispatch(remove_klientidAustriaaccept(removepayload))
      };
 
    useEffect(() => {
        // Countdown timer logic
        const timer = setInterval(() => {
          setSeconds((prevSeconds: number) => {
            if (prevSeconds === 0) {
              clearInterval(timer); // Stop the timer when countdown reaches 0
             handleOpen();
              return 0;
            }
            return prevSeconds - 1;
          });
        }, 1000);
    
        // Cleanup function to clear the interval when component unmounts
        return () => clearInterval(timer);
      }, []);


      const progress = (seconds / props.seconds) * 100

      let barcolor: string;
      if (progress <= 33) {
        barcolor = 'red'; 
      } else  if (progress <= 66) {
        barcolor = 'yellow';
      } else {
        barcolor = 'green'; 
      }
 
  return (
    <>
    <Progress color={barcolor} label={`${seconds} Sekunden`} value={progress} animate={true} size="xl"/>

    <Modal
        title=""
        opened={opened}
        onClose={handleClose}
        closeOnClickOutside={false}
        withCloseButton={false}
        size="md"
        shadow="sm"
        centered
        > 
          <Alert title={modalheadertext} color="red">
            {modalcontenttext}
        </Alert>
          <hr />
          <Grid>
            <Grid.Col span={12}>
            <Button fullWidth color="green" variant="light" onClick={handleOkClick}>{modalbuttontext}</Button>
            </Grid.Col>
          </Grid>
      </Modal> 
    </>
  );
}

export default TimerDisplay;

